const $ = window.jQuery;

$(function () {
	
    // Function to setup the sticky banner on the hero lockup banner
	function handleScroll() { 
		const setIsSticky = document.querySelector('.sticky-element');
		
		// Cancel sticky if on mobile
		const siteWidth = window.innerWidth;
		if (siteWidth <= 1024) return; 

		// Cancel sticky if element does not exist
		const stickyBarrier = document.getElementById('fixed-banner');
		if (!stickyBarrier) return;
	}

	// Listen to scroll and resize events
	window.addEventListener('scroll', handleScroll);
	window.addEventListener('resize', handleScroll);

	// Trigger on load
    handleScroll();
    
});
